(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ku-account-downloads"]) return;
  try {
    
(function () {
  // Clientseitige Suche
  var searchInput = document.getElementById('ku-dl-search-input');
  var items = document.querySelectorAll('.ku-dl-item[data-title]');
  var countEl = document.getElementById('ku-dl-count');
  if (searchInput) {
    searchInput.addEventListener('input', function () {
      var q = this.value.toLowerCase().trim();
      var visible = 0;
      items.forEach(function (item) {
        var title = item.getAttribute('data-title').toLowerCase();
        var show = !q || title.indexOf(q) !== -1;
        item.style.display = show ? '' : 'none';
        if (show) visible++;
      });
      if (countEl) countEl.textContent = visible + (visible === 1 ? ' Material' : ' Materialien') + ' verfügbar';
    });
  }

  // Header-Höhe für sticky Sidebar
  function updateHeaderH() {
    var header = document.querySelector('.ku-header-section');
    if (header) document.documentElement.style.setProperty('--ku-header-h', header.offsetHeight + 'px');
  }
  updateHeaderH();
  window.addEventListener('resize', updateHeaderH);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ku-bildung"] && !Shopify.designMode) return;
  try {
    
(function () {
  // Header-Höhe → sticky Subnav-Offset
  function updateHeaderH() {
    var header = document.querySelector('.ku-header-section');
    if (header) {
      document.documentElement.style.setProperty('--ku-header-h', header.offsetHeight + 'px');
    }
  }
  updateHeaderH();
  window.addEventListener('resize', updateHeaderH);

  // Scroll-Spy für Subnav
  var nav = document.getElementById('kuEduNav');
  if (nav) {
    var links = Array.prototype.slice.call(nav.querySelectorAll('a[href^="#"]'));
    var map = {};
    links.forEach(function (a) {
      var id = a.getAttribute('href').slice(1);
      var sec = document.getElementById(id);
      if (sec) map[id] = a;
    });
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          links.forEach(function (a) { a.removeAttribute('aria-current'); });
          if (map[e.target.id]) map[e.target.id].setAttribute('aria-current', 'true');
        }
      });
    }, { rootMargin: '-40% 0px -55% 0px', threshold: 0 });
    Object.keys(map).forEach(function (id) { obs.observe(document.getElementById(id)); });
  }

  // Seminar-CTA → Formular vorbelegen + Scrollen
  var sel = document.getElementById('ku-edu-thema');
  document.querySelectorAll('.ku-edu-seminar__cta').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var wanted = btn.getAttribute('data-seminar');
      if (sel && wanted) {
        var opts = Array.prototype.slice.call(sel.options);
        var match = opts.find(function (o) {
          return o.text.trim() === wanted.trim() || o.text.indexOf(wanted) !== -1;
        });
        if (match) sel.value = match.value;
      }
      var target = document.getElementById('ku-edu-anfragen');
      if (target) {
        var headerH = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--ku-header-h')) || 0;
        window.scrollTo({
          top: target.getBoundingClientRect().top + window.pageYOffset - headerH - 60,
          behavior: 'smooth'
        });
      }
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ku-konzept"] && !Shopify.designMode) return;
  try {
    
// Subnav-Top dynamisch an die echte Header-Höhe anpassen
(function () {
  function setSubnavTop() {
    var headerSection = document.querySelector('.ku-header-section');
    var h = headerSection ? headerSection.offsetHeight : 77;
    document.documentElement.style.setProperty('--ku-subnav-top', h + 'px');
  }
  setSubnavTop();
  window.addEventListener('resize', setSubnavTop, { passive: true });
})();

// Scroll-Spy für den mitlaufenden roten Faden
(function () {
  var nav = document.getElementById('kuKonzeptNav');
  if (!nav) return;
  var links = Array.prototype.slice.call(nav.querySelectorAll('a[href^="#"]'));
  var map = {};
  links.forEach(function (a) {
    var id = a.getAttribute('href').slice(1);
    var sec = document.getElementById(id);
    if (sec) map[id] = a;
  });
  var ids = Object.keys(map);
  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) {
        links.forEach(function (a) { a.removeAttribute('aria-current'); });
        var a = map[e.target.id];
        if (a) a.setAttribute('aria-current', 'true');
      }
    });
  }, { rootMargin: '-40% 0px -55% 0px' });
  ids.forEach(function (id) { if (map[id]) obs.observe(map[id].__sec || document.getElementById(id)); });
  // re-observe the actual section elements
  ['ku-konzept', 'ku-material', 'ku-begleitung'].forEach(function (id) {
    var el = document.getElementById(id);
    if (el) obs.observe(el);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
